// extracted by css-extract-rspack-plugin
export default {"rightRailContainer":"rightRailContainer-n_Telt","patientDetailsHeader":"patientDetailsHeader-WsmCJu"};